import request from '@/utils/request'

/**
 * 保存服务信息
 * @param {Object} data 服务信息数据
 * @returns {Promise} 返回Promise对象
 */
export function saveService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.saveService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function listServices(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.listServices',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存服务提供信息
 * @param {Object} data 服务提供信息数据
 * @returns {Promise} 返回Promise对象
 */
export function saveServiceProvide(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceProvide.saveServiceProvide',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}